
<div *ngIf="privilegesView==='AccessDenied'||id==='lock'||id===''" class=" outside-container  mt-4" >
  <div class="box-container">
    <div class="container">
      <div  class="  d-flex justify-content-center" >

  <img src="../../../assets/images/AccessDeniedError.png" alt="">
</div>

 </div>
</div>
</div>

<div *ngIf="privilegesView==='VAMD'&&id!='lock'&&id!=''" class="outside-container mt-4">
  <div class="box-container ">
      <div class="container">
          <div class="title ">

            <div class="row">
              <div class=" col-md-2  " ><div class="pointer d-flex justify-content-start "  (click)="backClick()" style="padding-left:20px;">⬅️</div></div>  
             <div class="col-md-7 d-flex justify-content-center">Air Configuration</div>
             <div class=" col-md-3 row ">
               <div class="d-flex justify-content-end">
                <button *ngIf="showTourCodes" class="btn btn-outline-primary btn-sm " (click)="onAddTour()"><img src="assets/images/Add_24.png"></button>
                <button *ngIf="showFares" class="btn btn-outline-primary btn-sm " (click)=" onAddfare()"><img src="assets/images/Add_24.png"></button>
                <button *ngIf="showfareRules" class="btn btn-outline-primary btn-sm " (click)="onAddfarRules()"><img src="assets/images/Add_24.png"></button>

             </div>
              </div>
            </div>
          
          </div> 
          </div>
          </div>
        </div>
        <div class="outside-container " *ngIf="privilegesView==='VAMD'&&id!='lock'&&id!=''" >
          <div class="box-container " >
              <div class="container" >
                 <div class="col-md-12 row d-flex justify-content-center " style="padding-left: 20px; ">
               
               
                <div class="col-md-2  " [ngStyle]="{'background-color':color?.sideBarColor}" style=" border-radius: 4px; content: right; padding-top: 10px; height:70vh;overflow-y: auto; ">
                  <div class="col-md-12 ">
                  <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"  (click)="onClickGeneral()" [ngClass]="{'activity' :showGeneralConfig}">General Config</span></span> 
                  <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns" (click)="onClickCache()" [ngClass]="{'activity' :showCacheConfig}">Cache Config</span></span> 
                  <span class=" d-flex justify-content-center mb-4" style=" height: 22px"> <span class=" btns"      (click)="onClickSource()" [ngClass]="{'activity' :showSourceConfig}">Source Config</span></span>
                   <span class=" d-flex justify-content-center mb-4" style=" height: 22px"> <span class=" btns"      (click)="onClickFare()" [ngClass]="{'activity' :showFares}">Private Fare</span></span> 
                  <span class=" d-flex justify-content-center mb-4" style=" height: 22px"> <span class=" btns"      (click)="onClickTour()" [ngClass]="{'activity' :showTourCodes}">Tour Codes</span></span>
                  <span *ngIf="userType==='STAFF'" class=" d-flex justify-content-center mb-4" style=" height: 22px"> <span class=" btns"      (click)="onClickfairRules()" [ngClass]="{'activity' :showfareRules}">Fares and Rules</span></span>
                  <span *ngIf="userType==='STAFF'" class=" d-flex justify-content-center mb-4" style=" height: 22px"> <span class=" btns"      (click)="onClickRBD()" [ngClass]="{'activity' :showRBD}">Passthrough RBD</span></span>

              </div>
                  
                </div>

                <div  class=" col-md-10 "  style="height:70vh; overflow-y: auto;">
                  <div *ngIf="showGeneralConfig" class="card col-md-12" style="min-height: 100%;">
                      <div class="  mt-3" style="padding: 10px;">
                          <form [formGroup]="GenRegFg"  autocomplete="off"  class=" row">
                          <mat-form-field class="col-md-3" appearance="outline">
                              <mat-label>Air Product</mat-label>
                              <mat-select matNativeControl name="airProduct"  formControlName="airProduct">
                                  <mat-option value="true">Enabled</mat-option>
                                  <mat-option value="false">Disabled</mat-option>
                                </mat-select>
                                <small *ngIf="GenRegFg.controls['airProduct'].dirty && GenRegFg.controls['airProduct'].invalid" class="warn">Please Select Air Product!</small>

                            </mat-form-field>
                            <mat-form-field class="col-md-3" appearance="outline">
                              <mat-label>B2E Enabled?</mat-label>
                              <mat-select matNativeControl name="b2eEnabled" formControlName="b2eEnabled" >
                                  <mat-option value="true">True</mat-option>
                                  <mat-option value="false">False</mat-option>
                                </mat-select>             
                                <small *ngIf="GenRegFg.controls['b2eEnabled'].dirty && GenRegFg.controls['b2eEnabled'].invalid" class="warn">Please Select B2E Enabled!</small>

                              </mat-form-field>
                            <mat-form-field class="col-md-3" appearance="outline">
                              <mat-label>B2B Enabled?</mat-label>
                              <mat-select matNativeControl name="b2benable" formControlName="b2bEnabled" >
                                  <mat-option value="true">True</mat-option>
                                  <mat-option value="false">False</mat-option>
                                </mat-select>             
                                <small *ngIf="GenRegFg.controls['b2bEnabled'].dirty && GenRegFg.controls['b2bEnabled'].invalid" class="warn">Please Select B2B Enabled!</small>

                              </mat-form-field>
                              
                            <mat-form-field class="col-md-3" appearance="outline">
                              <mat-label>B2C Enabled?</mat-label>
                              <mat-select matNativeControl name="b2cEnable" formControlName="b2cEnabled" >
                                  <mat-option value="true">True</mat-option>
                                  <mat-option value="false">False</mat-option>
                                </mat-select>                   
                                <small *ngIf="GenRegFg.controls['b2cEnabled'].dirty && GenRegFg.controls['b2cEnabled'].invalid" class="warn">Please Select B2C Enabled!</small>

                              </mat-form-field>
                            <mat-form-field class="col-md-3" appearance="outline">
                              <mat-label> Domestic Enabled?</mat-label>
                              <mat-select matNativeControl name="domesticEnabled"  formControlName="domesticEnabled">
                                  <mat-option value="true">True</mat-option>
                                  <mat-option value="false">False</mat-option>
                                </mat-select>                 
                                <small *ngIf="GenRegFg.controls['domesticEnabled'].dirty && GenRegFg.controls['domesticEnabled'].invalid" class="warn">Please Select Domastic Enabled!</small>
                              </mat-form-field>
                            <mat-form-field class="col-md-3" appearance="outline">
                              <mat-label>International Enabled?</mat-label>
                              <mat-select matNativeControl name="intEnabled"  formControlName="internationalEnabled">
                                  <mat-option value="true">True</mat-option>
                                  <mat-option value="false">False</mat-option>
                                </mat-select>               
                                <small *ngIf="GenRegFg.controls['internationalEnabled'].dirty && GenRegFg.controls['internationalEnabled'].invalid" class="warn">Please Select International Enabled!</small>
                              </mat-form-field>
                            <mat-form-field class="col-md-3" appearance="outline">
                              <mat-label> Domestic Multi Enabled?</mat-label>
                              <mat-select matNativeControl name="airProduct"  formControlName="domesticMultiEnabled">
                                  <mat-option value="true">True</mat-option>
                                  <mat-option value="false">False</mat-option>
                                </mat-select>                     
                                <small *ngIf="GenRegFg.controls['domesticMultiEnabled'].dirty && GenRegFg.controls['domesticMultiEnabled'].invalid" class="warn">Please Select Domastic Multi Enabled !</small>
                              </mat-form-field>
                            <!-- <mat-form-field class="col-md-4" appearance="outline">
                              <mat-label>Show Seats Availability</mat-label>
                              <input matInput type="text" name="name" autocomplete="off">
                            </mat-form-field>
                            <mat-form-field class="col-md-4" appearance="outline">
                              <mat-label>Max Segment For Multicity</mat-label>
                              <input matInput type="text" name="name" autocomplete="off">
                            </mat-form-field> -->
                            <div *ngIf="!showGenSave" class="d-flex justify-content-end " style="padding: 10px;">
                              <button  class="btn btn-outline-success c-width-100px shadow " style="padding-left: 22px; padding-right: 20px;" (click)="AddGeneralConfig()" [disabled]="GenRegFg.invalid" >Save</button>
                          </div>
                          <div *ngIf="showGenSave" class="d-flex justify-content-end " style="padding: 10px;">
                            <button  class="btn btn-outline-success c-width-100px shadow " style="padding-left: 22px; padding-right: 20px;" (click)="updateGeneralConfig()" [disabled]="GenRegFg.invalid" >Update</button>
                        </div>
                          </form>
                            
                        
                      
                      </div> 
                  </div>
                  
                  <div *ngIf="showCacheConfig" class="card col-md-12" style="min-height: 100%;">
                      <div class=" row mt-3" style="padding: 10px;">
                        <form [formGroup]="CacheRegFg"  autocomplete="off"  class=" row">

                          
                            <mat-form-field class="col-md-4" appearance="outline">
                              <mat-label>Dom Cache Enabled?</mat-label>
                              <mat-select matNativeControl name="airProduct"  formControlName="domCacheEnabled">
                                  <mat-option value="true">True</mat-option>
                                  <mat-option value="false">False</mat-option>
                                </mat-select>                             
                               </mat-form-field>
                            <mat-form-field class="col-md-4" appearance="outline">
                              <mat-label>International Cache Enabled?</mat-label>
                              <mat-select matNativeControl name="airProduct"  formControlName="internationalCacheEnabled">
                                  <mat-option value="true">True</mat-option>
                                  <mat-option value="false">False</mat-option>
                                </mat-select>                              
                               </mat-form-field>
                            <mat-form-field class="col-md-4" appearance="outline">
                              <mat-label>Dom Cache Expiry Time</mat-label>
                              <div class="input-with-icon col-md-12">

                                <input matInput minlength=1  (keypress)="onlyNumberKey($event)" name="expiry time" autocomplete="off" formControlName="domCacheExpiryTime"  (input)="Change($event,'DomCacheExp')">
                                <small *ngIf="DomCacheExp">Second</small>
                               </div> </mat-form-field>
                            <mat-form-field class="col-md-4" appearance="outline">
                              <mat-label>Is International Cache Expiry Time</mat-label>
                              <div class="input-with-icon col-md-12">

                                <input matInput minlength=1 (keypress)="onlyNumberKey($event)" name="expiry time" autocomplete="off" (input)="Change($event,'CacheExp')" formControlName="internationalCacheExpiryTime">
                                <small *ngIf="CacheExp">Second</small>
                               </div>     </mat-form-field>
                            <mat-form-field class="col-md-4" appearance="outline">
                              <mat-label> Itinerary Search Expiry time</mat-label>
                              <div class="input-with-icon col-md-12">

                                <input matInput minlength=1 (keypress)="onlyNumberKey($event)" (input)="Change($event,'searchExp')" formControlName="itinerarySearchExpiryTime"  name="expiry time" autocomplete="off" >
                                <small *ngIf="searchExp">Second</small>
                               </div>                            </mat-form-field>
                            <mat-form-field class="col-md-4" appearance="outline" >
                              <mat-label> Itinerary Confirm Expiry time</mat-label>
                              <div  class="input-with-icon col-md-12">

                            <input matInput minlength=1 (keypress)="onlyNumberKey($event)" name="expiry time" autocomplete="off" formControlName="itineraryConfirmExpiryTime" (input)="Change($event,'confirmExp')">
                            <small *ngIf="confirmExp">Second</small>
                           </div>
                            </mat-form-field>
                           
                            </form>
                           
                        
                      
                      </div> 
                      <div class="d-flex justify-content-end" style="padding: 10px;">
                          <button *ngIf="!showCacheUpdate" class="btn btn-outline-success c-width-100px shadow " style="padding-left: 22px; padding-right: 20px;" (click)="AddCacheConfig()" [disabled]="CacheRegFg.invalid" >Save</button>
                          <button *ngIf="showCacheUpdate" class="btn btn-outline-success c-width-100px shadow " style="padding-left: 22px; padding-right: 20px;" (click)="AddCacheConfig()" [disabled]="CacheRegFg.invalid" >Update</button>

                        </div>
                  </div>
                  <div *ngIf="showSourceConfig" class="card col-md-12" style="min-height: 100%; min-height: 100%; overflow-y: scroll" >

                    <form   autocomplete="off"  class=" row">

                          <table mat-table
                          [dataSource]="sourceList" multiTemplateDataRows style="background-color: transparent;">
                          <ng-container matColumnDef="expand">
                          <th  mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
                          <td mat-cell *matCellDef="let element">
                          <button mat-icon-button aria-label="expand row" (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
                            <mat-icon *ngIf="expandedElement !== element">arrow_right</mat-icon>
                            <mat-icon *ngIf="expandedElement === element">arrow_drop_down</mat-icon>
                          </button>
                          </td>
                          </ng-container>
                         
                          <ng-container matColumnDef="source" >
                           <th mat-header-cell *matHeaderCellDef>supplier/Source </th>
                           <td mat-cell *matCellDef="let element;" style="padding: 4px;"> 
                            <span class="form-control">
                              {{filterSupplierCode(element.supplierCode)+" / "+element.name}}
                              
                            </span>
                           
                            
                          
                          </td>
                          </ng-container>
                          <!-- Emp Id -->
                          <ng-container matColumnDef="b2e">
                            <th mat-header-cell *matHeaderCellDef>B2E Enabled?</th>
                            <td mat-cell *matCellDef="let element"  style="padding: 4px;">  
                             
                             <div class="col-md-12 ">
                               <mat-select matNativeControl class="form-control small font " name="b2e" [(ngModel)]="element.sourceConfig[0].b2eEnabled" [ngModelOptions]="{standalone: true}">
                                   <mat-option  class="mat-primary" value="true">True</mat-option>
                                   <mat-option  class="mat-primary" value="false">False</mat-option>
                   
                                 </mat-select>  
                               </div>
                           </td>
                          </ng-container>
                           <ng-container matColumnDef="b2b">
                             <th mat-header-cell *matHeaderCellDef>B2B Enabled?</th>
                             <td mat-cell *matCellDef="let element"  style="padding: 4px;">  
                              
                              <div class="col-md-12 ">
                                <mat-select matNativeControl class="form-control small font " name="b2b" [(ngModel)]="element.sourceConfig[0].b2bEnabled" [ngModelOptions]="{standalone: true}">
                                    <mat-option  class="mat-primary" value="true">True</mat-option>
                                    <mat-option  class="mat-primary" value="false">False</mat-option>
                    
                                  </mat-select>  
                                </div>
                            </td>
                           </ng-container>
                          <!-- Name Column -->
                          <ng-container matColumnDef="b2c">
                           <th mat-header-cell *matHeaderCellDef> B2C Enabled? </th>
                           <td mat-cell *matCellDef="let element" style="padding: 4px;"> 
                             
                                  <div class="col-md-12 ">
                                    <mat-select matNativeControl class="form-control small font " name="b2c" [(ngModel)]="element.sourceConfig[0].b2cEnabled" [ngModelOptions]="{standalone: true}">
                                        <mat-option  class="mat-primary" value="true">True</mat-option>
                                        <mat-option  class="mat-primary" value="false">False</mat-option>
                        
                                      </mat-select>  
                                    </div>
                           </td>
                          </ng-container>
                          
                          <!-- email Column -->
                          <ng-container matColumnDef="timeBefore">
                           <th mat-header-cell *matHeaderCellDef> Time Before Search </th>
                           <td mat-cell *matCellDef="let element" style="padding: 4px;"> 
                               <div  class="input-with-icon col-md-12">
                                  <input  type="text" class="form-control small" (keypress)="onlyNumberKey($event)"  [(ngModel)]="element.sourceConfig[0].timeBeforeSearch" [ngModelOptions]="{standalone: true}"> 
                                <span>Minute</span>
                              </div>
                             </td>
                          </ng-container>
                          <ng-container matColumnDef="changeClass">
                            <th mat-header-cell *matHeaderCellDef>Change Class Option</th>
                            <td mat-cell *matCellDef="let element" style="padding: 4px;">
                              <!-- <div class="input-with-icon col-md-12" >
                              <select class="form-control small font " name="b2b" [(ngModel)]="element.sourceConfig[0].changeClassOption" [ngModelOptions]="{standalone: true}">
                                  <option class="font" value="true" >Show</option>
                                  <option class="font" value="false" >Don't Show</option>

                                </select>
                                <mat-icon>arrow_drop_down</mat-icon>
                              </div>  -->
                            
                              <div class="col-md-12 ">
                                <mat-select matNativeControl class="form-control small font " name="classOption" [(ngModel)]="element.sourceConfig[0].changeClassOption" [ngModelOptions]="{standalone: true}">
                                    <mat-option style="width: 200px;" class="mat-primary" value="true">Show</mat-option>
                                    <mat-option style="width: 200px;" class="mat-primary" value="false">Don't Show</mat-option>
                    
                                  </mat-select>  
                                </div>
                            </td>
                           </ng-container>
                           <ng-container matColumnDef="button">
                            <th mat-header-cell *matHeaderCellDef>Action </th>
                            <td mat-cell *matCellDef="let element" style="padding: 4px;"> 
                              <div *ngIf="element.showsourceSave!=true" class="d-flex justify-content-center " >
                                <button  class="btn btn-outline-success c-width-100px shadow " style="padding-left: 22px; padding-right: 20px;" (click)="AddSourceConfig(element.code,element.supplierCode,element.sourceConfig)"  [disabled]="SourceRegFg.invalid" >&nbsp;&nbsp;Save&nbsp;&nbsp;</button>
                            </div>
                            <div  *ngIf="element.showsourceSave===true" class="d-flex justify-content-center "  >
                              <button  class="btn btn-outline-success c-width-100px shadow " style="padding-left: 22px; padding-right: 20px;" (click)="updateSourceConfig(element.code,element.supplierCode,element.sourceConfig)"  [disabled]="SourceRegFg.invalid" >Update</button>
                          </div>
                              </td>
                           </ng-container>
                          <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                          <ng-container matColumnDef="expandedDetail">
                          <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
                          <div class="mat-card example-element-detail row" 
                           [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                           
                           <div class=" col-md-12 row mt-3 " >
                                  <mat-form-field class="col-md-4" appearance="outline" >
                                      <mat-label>Client Id</mat-label>
                                      <input matInput type="text" name="clientId" autocomplete="off"  [(ngModel)]="element.sourceConfig[0].clientId" [ngModelOptions]="{standalone: true}">
                                    </mat-form-field>
                                    <mat-form-field class="col-md-4" appearance="outline">
                                      <mat-label>User Name</mat-label>
                                      <input matInput type="text" name="userName" autocomplete="off"  [(ngModel)]="element.sourceConfig[0].userName" [ngModelOptions]="{standalone: true}">
                                    </mat-form-field>
                                    
                                    <mat-form-field class="col-md-4" appearance="outline">
                                      <mat-label>Password(Set)</mat-label>
                                      <input matInput type="password" name="password" autocomplete="new-password"  [(ngModel)]="element.sourceConfig[0].password" [ngModelOptions]="{standalone: true}">
                                    </mat-form-field>
                                    <mat-form-field class="col-md-4" appearance="outline">
                                      <mat-label>Transaction HAP / Office Id </mat-label>
                                      <input matInput type="text" name="HAP" autocomplete="off"  [(ngModel)]="element.sourceConfig[0].officeId" [ngModelOptions]="{standalone: true}">
                                    </mat-form-field>
                                    <mat-form-field class="col-md-4" appearance="outline">
                                      <mat-label>Transaction Password(Unset)</mat-label>
                                      <input matInput type="password" name="transaction" autocomplete="new-password"  [(ngModel)]="element.sourceConfig[0].transactionPassword" [ngModelOptions]="{standalone: true}">
                                    </mat-form-field>
                                  
                               
                              
                                <mat-form-field class="col-md-4" appearance="outline">
                                  <mat-label>Profile</mat-label>
                                  <input matInput type="text" name="profile" autocomplete="off"  [(ngModel)]="element.sourceConfig[0].profile" [ngModelOptions]="{standalone: true}">
                                </mat-form-field>
                                <mat-form-field class="col-md-4" appearance="outline" >
                                  <mat-label>Fare PCC</mat-label>
                                  <input matInput type="text" name="farepcc" autocomplete="off"  [(ngModel)]="element.sourceConfig[0].farePcc" [ngModelOptions]="{standalone: true}">
                                </mat-form-field>
                                <mat-form-field class="col-md-4" appearance="outline">
                                  <mat-label>Search PCC</mat-label>
                                  <input matInput type="text" name="searchPcc" autocomplete="off"  [(ngModel)]="element.sourceConfig[0].searchPcc" [ngModelOptions]="{standalone: true}">
                                </mat-form-field>
                                <mat-form-field class="col-md-4" appearance="outline">
                                  <mat-label>Transaction Profile</mat-label>
                                  <input matInput type="text" name="transaction" autocomplete="off"  [(ngModel)]="element.sourceConfig[0].transactionProfile" [ngModelOptions]="{standalone: true}">
                                </mat-form-field>
                               
                                <mat-form-field class="col-md-4" appearance="outline">
                                  <mat-label>Url</mat-label>
                                  <input matInput type="text" name="url" autocomplete="off"  [(ngModel)]="element.sourceConfig[0].url" [ngModelOptions]="{standalone: true}">
                                </mat-form-field>
                              
                               
                                <mat-form-field class="col-md-4" appearance="outline">
                                  <mat-label>Supplier Currency / INR</mat-label>
                                  <input matInput type="text" name="currency" autocomplete="off"  [(ngModel)]="element.sourceConfig[0].currency" [ngModelOptions]="{standalone: true}">
                                </mat-form-field>
                                <mat-form-field class="col-md-4" appearance="outline">
                                  <mat-label>Queue Number</mat-label>
                                  <input matInput type="text" name="queue" autocomplete="off"  [(ngModel)]="element.sourceConfig[0].transactionId" [ngModelOptions]="{standalone: true}">
                                </mat-form-field>

                                <mat-form-field class="col-md-4" appearance="outline" >
                                  <mat-label>Fare Type (separated by ,)</mat-label>
                                  <input matInput type="text" name="fareType" autocomplete="off" [(ngModel)]="element.sourceConfig[0].fareType" [ngModelOptions]="{standalone: true}" >
                                </mat-form-field>
                                <mat-form-field class="col-md-4" appearance="outline">
                                  <mat-label>Fare Basis (separated by ,)</mat-label>
                                  <input matInput type="text" name="fareBasis" autocomplete="off"  [(ngModel)]="element.sourceConfig[0].fareBasis" [ngModelOptions]="{standalone: true}">
                                </mat-form-field>
                                <mat-form-field class="col-md-4" appearance="outline">
                                  <mat-label>Non Refundable Fare Basis Code (separated by ,)</mat-label>
                                  <input matInput type="text" name="nonBasis" autocomplete="off"   [(ngModel)]="element.sourceConfig[0].nonRefundableFareBasisCode" [ngModelOptions]="{standalone: true}" >
                                </mat-form-field>
                                <mat-form-field class="col-md-4" appearance="outline">
                                  <mat-label>Product Class</mat-label>
                                  <input matInput type="text" name="productClass" autocomplete="off"  [(ngModel)]="element.sourceConfig[0].productClass" [ngModelOptions]="{standalone: true}" >
                                </mat-form-field>
                                <mat-form-field class="col-md-4" appearance="outline">
                                  <mat-label>Non Refundable Product Classes (separated by ,)</mat-label>
                                  <input matInput type="text" name="nonproduct" autocomplete="off"   [(ngModel)]="element.sourceConfig[0].nonRefundableProductClass" [ngModelOptions]="{standalone: true}" >
                                </mat-form-field>
                                

                                <div class="col-md-8 row " style="margin-left: 1px;">
                                <div class="col-md-12 card">
                                  <span class="panel-label">Include/Exclude  </span>

                                <div class="col-md-12 row pt-3" >
                                <mat-form-field *ngIf="!element.sourceConfig[0].carrierRule" class="col-md-6" appearance="outline">
                                  <mat-label>Include/Exclude</mat-label>
                                  <mat-select [(ngModel)]="element.sourceConfig[0].carrierRule" name="selection" >
                                    <mat-option value="I">Include</mat-option>
                                    <mat-option value="X">Exclude</mat-option>
                                  </mat-select>
                                </mat-form-field>
                                <mat-form-field *ngIf="element.sourceConfig[0].carrierRule==='I'" class="col-md-6" appearance="outline">
                                  <mat-label>Include/Exclude</mat-label>
                                  <mat-select [(ngModel)]="element.sourceConfig[0].carrierRule" name="selection" >
                                    <mat-option value="I">Include</mat-option>
                                    <mat-option value="X">Exclude</mat-option>
                                  </mat-select>
                                </mat-form-field>
                                <mat-form-field *ngIf="element.sourceConfig[0].carrierRule==='X'" class="col-md-6" appearance="outline">
                                  <mat-label>Include/Exclude</mat-label>
                                  <mat-select [(ngModel)]="element.sourceConfig[0].carrierRule" name="selection" >
                                    <mat-option value="I">Include</mat-option>
                                    <mat-option value="X">Exclude</mat-option>
                                  </mat-select>
                                </mat-form-field>
                                
                                <mat-form-field class="col-md-6" appearance="outline" *ngIf="element.sourceConfig[0].carrierRule === 'I'">
                                  <mat-label>Include (Carrier Code separated by :)</mat-label>
                                  <input matInput type="text" name="include" autocomplete="off" [(ngModel)]="element.sourceConfig[0].include" [ngModelOptions]="{standalone: true}">
                                </mat-form-field>
                                
                                <mat-form-field class="col-md-6" appearance="outline" *ngIf="element.sourceConfig[0].carrierRule === 'X'">
                                  <mat-label>Exclude (Carrier Code separated by :)</mat-label>
                                  <input matInput type="text" name="exclude" autocomplete="off" [(ngModel)]="element.sourceConfig[0].exclude" [ngModelOptions]="{standalone: true}">
                                </mat-form-field>
                              </div>
                            </div>
                          </div>
                               
                            </div>
                          </div>
                          </td>
                          </ng-container>
                          
                          <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
                          <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand;"
                          class="example-element-row">
                          </tr>
                          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                          <tr class="mat-row" *matNoDataRow>
                          <td  class="mat-cell" colspan="4">There is no data in this table</td>
                          </tr>
                          </table>
                          
                          </form>


               </div>
               <div *ngIf="showTourCodes" class="card col-md-12" style="min-height: 100%;">

                  <table mat-table [dataSource]="tourData"
                   multiTemplateDataRows style="background-color: transparent;">
                  <!-- <ng-container matColumnDef="expand">
                  <th  mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
                  <td mat-cell *matCellDef="let element">
                  <button mat-icon-button aria-label="expand row" (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
                    <mat-icon *ngIf="expandedElement !== element">arrow_right</mat-icon>
                    <mat-icon *ngIf="expandedElement === element">arrow_drop_down</mat-icon>
                  </button>
                  </td>
                  </ng-container> -->
                 
                 
                   <ng-container matColumnDef="enabled">
                     <th mat-header-cell *matHeaderCellDef>Enabled</th>
                     <td mat-cell *matCellDef="let element"  style="padding: 4px;">  
                      <mat-icon *ngIf="element.status===true" class='font-16-green-icon'>check_circle</mat-icon>
                      <mat-icon *ngIf="element.status===false" class='font-16-red-icon'>cancel</mat-icon>
        
                       </td>

                   </ng-container>
                   <ng-container matColumnDef="tourCode">
                    <th mat-header-cell *matHeaderCellDef> Tour Code </th>
                    <td mat-cell *matCellDef="let element" style="padding: 4px; cursor: pointer; color: rgb(24,118,209);" (click)="rowTourClick(element)"> 
                      {{element.code}}
                       </td>
                   </ng-container>
                   <ng-container matColumnDef="fareCode">
                    <th mat-header-cell *matHeaderCellDef> Private Fare Code </th>
                    <td mat-cell *matCellDef="let element" style="padding: 4px;"> {{element.pfCode}}
                         </td>
                   </ng-container>
                  <ng-container matColumnDef="supplier">
                   <th mat-header-cell *matHeaderCellDef>Supplier </th>
                   <td mat-cell *matCellDef="let element" style="padding: 4px;"> 
                      {{element.supplierCode}}
                   </td>
                  </ng-container>
                  
                 
                  <ng-container matColumnDef="source">
                   <th mat-header-cell *matHeaderCellDef> Source </th>
                   <td mat-cell *matCellDef="let element" style="padding: 4px;"> {{element.sourceCode}}
                       </td>
                  </ng-container>
                  
                  <ng-container matColumnDef="carrier">
                    <th mat-header-cell *matHeaderCellDef>Carrier</th>
                    <td mat-cell *matCellDef="let element" style="padding: 4px;">
                     {{element.carrierCode}}
                       </td>
                   </ng-container>
                  
                  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                 
                  
                  <tr mat-header-row *matHeaderRowDef="columnsTourCodeWithExpand"></tr>
                  <!-- <tr mat-row *matRowDef="let element; columns: columnsTourCodeWithExpand;"
                  class="example-element-row">
                  </tr> -->
                  <tr mat-row *matRowDef="let row; columns: columnsTourCodeWithExpand" class="example-detail-row"></tr>
                  <tr class="mat-row" *matNoDataRow>
                  <td  class="mat-cell" colspan="4">There is no data in this table</td>
                  </tr>
                  </table>
            </div>
            
                <div *ngIf="showFares" class="card col-md-12" style="min-height: 100%;">
                  <table mat-table [dataSource]="fareData"
                  multiTemplateDataRows style="background-color: transparent;">

                  <ng-container matColumnDef="enabled">
                    <th mat-header-cell *matHeaderCellDef>Enabled</th>
                    <td mat-cell *matCellDef="let element" style="padding: 4px;">
                      <mat-icon *ngIf="element.enabled===true" class='font-16-green-icon'>check_circle</mat-icon>
                      <mat-icon *ngIf="element.enabled===false" class='font-16-red-icon'>cancel</mat-icon>
        
                       </td>
                   </ng-container>
                   <ng-container matColumnDef="privateFareCode">
                    <th mat-header-cell *matHeaderCellDef>Private Fare Code</th>
                    <td mat-cell *matCellDef="let element" style="padding: 4px; cursor: pointer; color: rgb(24,118,209);" (click)="rowFareClick(element)" >
                       {{element.privateFareCode}}
                       </td>
                   </ng-container>
                  <ng-container matColumnDef="priority">
                    <th mat-header-cell *matHeaderCellDef>Priority </th>
                    <td mat-cell *matCellDef="let element" style="padding: 4px;"> {{element.priority}}
                       </td>
                   </ng-container>
                  <ng-container matColumnDef="sourceCode">
                    <th mat-header-cell *matHeaderCellDef>Source</th>
                    <td mat-cell *matCellDef="let element"  style="padding: 4px;"> {{element.sourceCode}} 
                      </td>
                  </ng-container>
                 <!-- Name Column -->
                 <ng-container matColumnDef="supplierCode">
                  <th mat-header-cell *matHeaderCellDef>Supplier </th>
                  <td mat-cell *matCellDef="let element" style="padding: 4px;"> 
                    {{element.supplierCode}} 
                  </td>
                 </ng-container>
                 
                 <!-- email Column -->
                 <ng-container matColumnDef="carrierCode">
                  <th mat-header-cell *matHeaderCellDef> Carrier </th>
                  <td mat-cell *matCellDef="let element" style="padding: 4px;"> 
                    {{element.carrierCode}}
                      </td>
                 </ng-container>
                 
                 
                  
                 
                 <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                
                 
                 <tr mat-header-row *matHeaderRowDef="columnsFareWithExpand"></tr>
                 
                 <tr mat-row *matRowDef="let row; columns: columnsFareWithExpand" class="example-detail-row"></tr>
                 <tr class="mat-row" *matNoDataRow>
                 <td  class="mat-cell" colspan="4">There is no data in this table</td>
                 </tr>
                 </table>
                </div>
                <div *ngIf="showfareRules" class="card col-md-12" style="min-height: 100%;">
               <app-fares-rules-config ></app-fares-rules-config> 
                </div>
                <div *ngIf="showRBD" class="card col-md-12" style="min-height: 100%;">
                  <app-rbd ></app-rbd> 
                   </div>

              </div>
                 </div>
                  
                  </div>
                  </div>
                </div>
                <div class="modal " id="myMod"  [style.display]="AddTourCodes ? 'block' : 'none'" >
                  <div class="modal-dialog" >
                      <div class="modal-content " >
                          <div class="modal-header title">
                            <h4 *ngIf="action==='newTour'" class="modal-title">Add Tour Code</h4>
                            <h4 *ngIf="action==='updateTour'" class="modal-title">Edit Tour Code</h4>

                            <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                            </div>
                            <div class="modal-body" style="max-height: 65vh;overflow: auto;">
                            <div class="col-md-12 mt-3 " *ngIf="AddTourCodes">
                              <div class="col-md-12 d-flex justify-content-center" >
                              <div class="col-md-12 row " >
                                  <div class=" col-md-12 ">
                                    
                                      <form [formGroup]="TourRegFg"   autocomplete="off"  class=" row" >
                                       
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Enabled</mat-label>
                                          <mat-select matNativeControl name="status" formControlName="status">
                                            <mat-option value="true">True</mat-option>
                                            <mat-option value="false">False</mat-option>
                                          </mat-select>

                                        </mat-form-field>
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Supplier</mat-label>
                                          <mat-select matNativeControl name="supplier" formControlName="supplierCode">
                                            
                                            <mat-option *ngFor="let item of sourceList" [value]="item.supplierCode">{{item.supplierCode}}</mat-option>
                                          </mat-select>  
                                        </mat-form-field>    
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Source</mat-label>
                                          <mat-select matNativeControl name="source" formControlName="sourceCode">
                                            
                                            <mat-option *ngFor="let item of sourceCodeList" [value]="item.code">{{item.title}}</mat-option>
                                          </mat-select>  
                                          <small *ngIf="TourRegFg.controls['sourceCode'].dirty && TourRegFg.controls['sourceCode'].invalid" class="warn">Please Select Source!</small>

                                        </mat-form-field>   
                                           
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Carrier</mat-label>
                                          <mat-select matNativeControl name="carrierCode" formControlName="carrierCode">
                                            <mat-option *ngFor="let item of carrierList" [value]="item.carrierName">{{item.carrierName}}</mat-option>
                                          </mat-select>  
                                          <small *ngIf="TourRegFg.controls['carrierCode'].dirty && TourRegFg.controls['carrierCode'].invalid" class="warn">Please Select Carrier!</small>

                                        </mat-form-field>   
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Tour Code</mat-label>
                                          <input matInput type="text" name="tourCode" formControlName="code" autocomplete="off">  
                                          <small *ngIf="TourRegFg.controls['code'].dirty && TourRegFg.controls['code'].invalid" class="warn">Please Enter Tour Code!</small>

                                        </mat-form-field> 
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Private Fare Code</mat-label>
                                          <mat-select matNativeControl name="pfTourCode" formControlName="pfCode">
                                            <mat-option *ngFor="let item of fareData" [value]="item.privateFareCode">{{item.privateFareCode}}</mat-option>
                                          </mat-select>  
                                          <small *ngIf="TourRegFg.controls['pfTourCode'].dirty && TourRegFg.controls['pfCode'].invalid" class="warn">Please Select Private Fare Code!</small>

                                        </mat-form-field>
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Priority</mat-label>
                                          <mat-select matNativeControl name="priority" formControlName="priority">
                                            <mat-option *ngFor="let number of numbers" [value]="number.toString()">{{ number }}</mat-option>
                                          </mat-select>  
                                          <small *ngIf="TourRegFg.controls['priority'].dirty && TourRegFg.controls['priority'].invalid" class="warn">Please Select Priority!</small>

                                        </mat-form-field> 
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Dom./Intl.</mat-label>
                                          <mat-select matNativeControl name="domIntl" formControlName="domIntl">
                                            <mat-option  value="">Both</mat-option>
                                            <mat-option  value="domestic">Domestic</mat-option>
                                            <mat-option  value="international">International</mat-option>
                                          </mat-select>  
                                          <small *ngIf="TourRegFg.controls['domIntl'].dirty && TourRegFg.controls['domIntl'].invalid" class="warn">Please Select Dom./Intl.!</small>

                                        </mat-form-field> 
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Endrosement</mat-label>
                                          <input matInput type="text" name="endorsement" formControlName="endorsement" autocomplete="off">  
                                          <small *ngIf="TourRegFg.controls['endorsement'].dirty && TourRegFg.controls['endorsement'].invalid" class="warn">Please Enter Endrosement!</small>

                                        </mat-form-field>  
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Net Discount</mat-label>
                                          <!-- <mat-select matNativeControl name="netDiscount" formControlName="netDiscount">
                                            <mat-option value="A">Not Applicable</mat-option>
                                            <mat-option value="I">Base Percentage</mat-option>
                                            <mat-option value="I">Base Absolute</mat-option>

                                          </mat-select> -->
                                        
                                          <input matInput type="text" name="netDiscount" (keypress)="onlyNumberKey($event)" formControlName="netDiscount">
                                          
                                          <small *ngIf="TourRegFg.controls['netDiscount'].dirty && TourRegFg.controls['netDiscount'].invalid" class="warn">Please enter Discount value!</small>
                                        </mat-form-field>   
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>OS</mat-label>
                                          <input matInput type="text" name="os" formControlName="os">
                                            <small *ngIf="TourRegFg.controls['os'].dirty && TourRegFg.controls['os'].invalid" class="warn">Please enter OS!</small>
                                        </mat-form-field>  
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Flight Regex</mat-label>
                                          <input matInput type="text" name="flightRegex" formControlName="flightRegex">
                                            <small *ngIf="TourRegFg.controls['flightRegex'].dirty && TourRegFg.controls['flightRegex'].invalid" class="warn">Please enter Flight Regex!</small>
                                        </mat-form-field>
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Class Regex</mat-label>
                                          <input matInput type="text" name="classRegex" formControlName="classRegex">
                                            <small *ngIf="TourRegFg.controls['classRegex'].dirty && TourRegFg.controls['classRegex'].invalid" class="warn">Please enter Class Regex!</small>
                                        </mat-form-field> 
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Basis Regex</mat-label>
                                          <input matInput type="text" name="basisRegex" formControlName="basisRegex">
                                            <small *ngIf="TourRegFg.controls['basisRegex'].dirty && TourRegFg.controls['basisRegex'].invalid" class="warn">Please enter Basis Regex!</small>
                                        </mat-form-field>   
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Cabin Class</mat-label>
                                          <input matInput type="text" name="cabinClass" formControlName="cabinClass">
                                            <small *ngIf="TourRegFg.controls['cabinClass'].dirty && TourRegFg.controls['cabinClass'].invalid" class="warn">Please enter Cabin Class!</small>
                                        </mat-form-field>   
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Journey Type</mat-label>
                                          <mat-select matNativeControl name="journeyType" formControlName="journeyType">
                                            <mat-option value="oneway">Oneway</mat-option>
                                            <mat-option value="return">Return</mat-option>

                                          </mat-select>     
                                         <small *ngIf="TourRegFg.controls['journeyType'].dirty && TourRegFg.controls['journeyType'].invalid" class="warn">Please Select Journey Type!</small>
                                        </mat-form-field>  
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Origin</mat-label>
                                          <input matInput type="text" name="origin" formControlName="origin">   
                                         <small *ngIf="TourRegFg.controls['origin'].dirty && TourRegFg.controls['origin'].invalid" class="warn">Please Enter Origin!</small>
                                        </mat-form-field>  
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Destination</mat-label>
                                          <input matInput type="text" name="destination" formControlName="destination">   
                                         <small *ngIf="TourRegFg.controls['destination'].dirty && TourRegFg.controls['destination'].invalid" class="warn">Please Enter Destination!</small>
                                        </mat-form-field>  
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Via Point</mat-label>
                                          <input matInput type="text" name="viaPoint" formControlName="viaPoint">   
                                         <small *ngIf="TourRegFg.controls['viaPoint'].dirty && TourRegFg.controls['viaPoint'].invalid" class="warn">Please Enter Via Point!</small>
                                        </mat-form-field>  
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Sector</mat-label>
                                          <input matInput type="text" name="sector" formControlName="sector">   
                                         <small *ngIf="TourRegFg.controls['sector'].dirty && TourRegFg.controls['sector'].invalid" class="warn">Please Enter sector!</small>
                                        </mat-form-field>  
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Sales Validity</mat-label>
                                          <input matInput type="text" name="salesValidity" formControlName="salesValidity">   
                                         <small *ngIf="TourRegFg.controls['salesValidity'].dirty && TourRegFg.controls['salesValidity'].invalid" class="warn">Please Enter Sales Validity!</small>
                                        </mat-form-field>   
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Sales Blackout</mat-label>
                                          <input matInput type="text" name="salesBlackout" formControlName="salesBlackout">   
                                         <small *ngIf="TourRegFg.controls['salesBlackout'].dirty && TourRegFg.controls['salesBlackout'].invalid" class="warn">Please Enter Sales Blackout!</small>
                                        </mat-form-field>  
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label> Travel Validity</mat-label>
                                          <input matInput type="text" name="travelValidity" formControlName="travelValidity">   
                                         <small *ngIf="TourRegFg.controls['travelValidity'].dirty && TourRegFg.controls['travelValidity'].invalid" class="warn">Please Enter  Travel Validity!</small>
                                        </mat-form-field>  
                                         <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Travel Blackout</mat-label>
                                          <input matInput type="text" name="travelBlackout" formControlName="travelBlackout">   
                                         <small *ngIf="TourRegFg.controls['travelBlackout'].dirty && TourRegFg.controls['travelBlackout'].invalid" class="warn">Please Enter Travel Blackout!</small>
                                        </mat-form-field> 
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <input matInput [matDatepicker]="pickers" formControlName="expiryDate">
                                          <mat-label>Expiry Date</mat-label>
                                          <mat-datepicker-toggle matIconSuffix [for]="pickers" ></mat-datepicker-toggle>
                                          <mat-datepicker #pickers></mat-datepicker>
                                          <small *ngIf="TourRegFg.controls['expiryDate'].dirty && TourRegFg.controls['expiryDate'].invalid" class="warn">Please Select Expiry Date!</small>

                                         </mat-form-field>   
                                         <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>PF Tour Code</mat-label>
                                          <input matInput type="text" name="pfTourCode" formControlName="pfTourCode">   
                                         <small *ngIf="TourRegFg.controls['pfTourCode'].dirty && TourRegFg.controls['pfTourCode'].invalid" class="warn">Please Enter PF Tour Code!</small>
                                        </mat-form-field>                    
                                        </form>
                                  </div>
                                  </div>
                                  </div>                                      
                            </div>
                          </div>
                              <div class="modal-footer">
                                <div class="form-group form-inline ">
                                  <label for="userName" class="col-md-5 col-form-label control-label"> </label>
                                </div>   
                                <button *ngIf="action==='newTour'" class="btn btn-outline-success c-width-100px shadow " (click)="AddTourCode()" [disabled]="TourRegFg.invalid" >Save</button>
                                <button *ngIf="action==='updateTour'" class="btn btn-outline-success c-width-100px shadow " (click)="updateTourCode()" [disabled]="TourRegFg.invalid">Update</button>

                                <button type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal"  (click)="closePopup()">Close</button>
                              </div>
                            
                            </div>
                    </div>
                </div>

                <div class="modal " id="myMod"  [style.display]="addfare ? 'block' : 'none'" >
                  <div class="modal-dialog" >
                      <div class="modal-content " >
                          <div class="modal-header title">
                            <h4 *ngIf="action==='newFare'" class="modal-title">Add Private Fare</h4>
                            <h4  *ngIf="action==='updateFare'" class="modal-title">Edit Private Fare</h4>

                            <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                            </div>
                            <div class="modal-body">
                            <div class="col-md-12 mt-3 " *ngIf="addfare">
                              <div class="col-md-12 d-flex justify-content-center" >
                              <div class="col-md-12 row " >
                                  <div class=" col-md-12 ">
                                    
                                      <form [formGroup]="fareRegFg"   autocomplete="off"  class=" row" >
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Private Fare Code</mat-label>
                                          <input matInput type="text" name="privateFareCode" formControlName="privateFareCode">   
 
                                          <small *ngIf="fareRegFg.controls['privateFareCode'].dirty && fareRegFg.controls['privateFareCode'].invalid" class="warn">Please Enter Private Fare Code!</small>

                                        </mat-form-field>
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Enabled</mat-label>
                                          <mat-select matNativeControl name="enabled" formControlName="enabled">
                                            <mat-option value="true">True</mat-option>
                                            <mat-option value="false">False</mat-option>
                                          </mat-select>
                                          
                                          <small *ngIf="fareRegFg.controls['enabled'].dirty && fareRegFg.controls['enabled'].invalid" class="warn">Please Select Enabled!</small>

                                        </mat-form-field>
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Supplier</mat-label>
                                          <mat-select matNativeControl name="supplier" formControlName="supplierCode">
                                            <mat-option *ngFor="let item of sourceList" [value]="item.supplierCode">{{item.supplierCode}}</mat-option>
                                          </mat-select>  
                                          <small *ngIf="fareRegFg.controls['supplierCode'].dirty && fareRegFg.controls['supplierCode'].invalid" class="warn">Please Select Dom./Intl.!</small>

                                        </mat-form-field>    
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Source</mat-label>
                                          <mat-select matNativeControl name="source" formControlName="sourceCode">
                                            <mat-option *ngFor="let item of sourceCodeList" [value]="item.code">{{item.title}}</mat-option>
                                          </mat-select>  
                                          <small *ngIf="fareRegFg.controls['sourceCode'].dirty && fareRegFg.controls['sourceCode'].invalid" class="warn">Please Select Source!</small>

                                        </mat-form-field>   
                                           
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Carrier</mat-label>
                                          <mat-select matNativeControl name="carrierCode" formControlName="carrierCode">
                                            <mat-option *ngFor="let item of carrierList" [value]="item.carrierName">{{item.carrierName}}</mat-option>
                                          </mat-select>  
                                          <small *ngIf="fareRegFg.controls['carrierCode'].dirty && fareRegFg.controls['carrierCode'].invalid" class="warn">Please Select Carrier!</small>

                                        </mat-form-field>   
                                        
                                       
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Priority</mat-label>
                                          <mat-select matNativeControl name="priority" formControlName="priority">
                                        <mat-option *ngFor="let number of numbers" [value]="number.toString()">{{ number }}</mat-option>
                                          </mat-select>  
                                          <small *ngIf="fareRegFg.controls['priority'].dirty && fareRegFg.controls['priority'].invalid" class="warn">Please Select Priority!</small>

                                        </mat-form-field> 
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Dom./Intl.</mat-label>
                                          <mat-select matNativeControl name="domIntl" formControlName="domIntl">                                           
                                            <mat-option  value="">Both</mat-option>
                                            <mat-option  value="domestic">Domestic</mat-option>
                                            <mat-option  value="international">International</mat-option>
                                          </mat-select>  
                                          <small *ngIf="fareRegFg.controls['domIntl'].dirty && fareRegFg.controls['domIntl'].invalid" class="warn">Please Select Dom./Intl.!</small>

                                        </mat-form-field> 
                                                         
                                        </form>
                                  </div>
                                  </div>
                                  </div>                                      
                            </div>
                              <div class="modal-footer">
                                <div class="form-group form-inline ">
                                  <label for="userName" class="col-md-5 col-form-label control-label"> </label>
                                </div>   
                                <button *ngIf="action==='newFare'" class="btn btn-outline-success c-width-100px shadow " (click)="AddPrivateFare()" [disabled]="fareRegFg.invalid" >Save</button>
                                <button *ngIf="action==='updateFare'" class="btn btn-outline-success c-width-100px shadow " (click)="updatePrivateFare()" [disabled]="fareRegFg.invalid" >Update</button>

                                <button type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                              </div>
                            </div>
                            </div>
                    </div>
                </div>